import { useState } from "react";
export const useSponsorsState = () => {
      const [sponsors, setSponsors] = useState([]);
      const [filteredSponsors, setFilteredSponsors] = useState([]);
      const [loading, setLoading] = useState(true);
      const [searchTerm, setSearchTerm] = useState("");
      const [activeFilter, setActiveFilter] = useState("all");
      const [adCounts, setAdCounts] = useState({});

      return {
        sponsors, setSponsors, filteredSponsors, setFilteredSponsors, loading, setLoading, searchTerm, setSearchTerm, activeFilter, setActiveFilter, adCounts, setAdCounts
      }
}